/**
 * Returns the search radius in miles based on the place type/s.
 * Different address granularities (street, city, state, etc.) require different search radius.
 *
 * @see https://developers.google.com/maps/documentation/places/web-service/supported_types
 */
export function getSearchRadiusByPlaceType(
  types: readonly string[] | string[] | undefined,
): number {
  const hasNoTypes = !types || types.length === 0;

  // ─────────────────────────────────────────────────────────────────────────────

  if (hasNoTypes) {
    return RADIUSES.SMALL;
  }

  // ─────────────────────────────────────────────────────────────────────────────

  if (
    types.includes('establishment') ||
    types.includes('street_address') ||
    types.includes('premise') ||
    types.includes('subpremise')
  ) {
    return RADIUSES.SMALLEST;
  }

  // ─────────────────────────────────────────────────────────────────────────────

  if (
    types.includes('neighborhood') ||
    types.includes('sublocality') ||
    types.includes('sublocality_level_1')
  ) {
    return RADIUSES.SMALL;
  }

  // ─────────────────────────────────────────────────────────────────────────────

  if (
    types.includes('administrative_area_level_2') ||
    types.includes('locality') ||
    types.includes('postal_code')
  ) {
    return RADIUSES.MEDIUM;
  }

  // ─────────────────────────────────────────────────────────────────────────────

  if (types.includes('administrative_area_level_1')) {
    return RADIUSES.LARGE;
  }

  // ─────────────────────────────────────────────────────────────────────────────

  return RADIUSES.SMALL;
}

// ─── Constants ───────────────────────────────────────────────────────────────

const RADIUSES = {
  SMALLEST: 2,
  SMALL: 15,
  MEDIUM: 40,
  LARGE: 200,
} as const;
